import React from 'react';
import TriggerBuilder from './TriggerBuilder';

const nodeTypes = [
    { type: 'start', label: 'Start Flow', category: 'Control' },
    { type: 'end', label: 'End Flow', category: 'Control' },
    { type: 'wait_event', label: 'Wait Event', category: 'Control' },
    { type: 'noop', label: 'No-Op / Branch', category: 'Control' },
    { type: 'send_text', label: 'Send Text', category: 'Message' },
    { type: 'send_image', label: 'Send Image', category: 'Message' },
    { type: 'send_button_message', label: 'Send Button', category: 'Message' },
    { type: 'send_list_message', label: 'Send List', category: 'Message' },
    { type: 'send_form', label: 'Send Form', category: 'Action' },
    { type: 'send_payment_link', label: 'Send Payment Link', category: 'Action' },
    { type: 'process_payment', label: 'Process Payment', category: 'Action' },
    { type: 'create_reservation', label: 'Create Reservation', category: 'Action' },
    { type: 'set_vars', label: 'Set Variables', category: 'Action' },
];

const Sidebar = ({ triggers, setTriggers }) => {
    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    const categories = [...new Set(nodeTypes.map(n => n.category))];

    return (
        <aside className="wf-sidebar-left">
            <TriggerBuilder triggers={triggers} setTriggers={setTriggers} />

            <div style={{ padding: '0 10px', marginTop: '20px' }}>
                <h3 className="wf-section-title">Nodes</h3>

                {categories.map(cat => (
                    <div key={cat}>
                        <div style={{ fontSize: '0.8rem', color: '#94a3b8', margin: '8px 0' }}>{cat}</div>
                        {nodeTypes.filter(n => n.category === cat).map((node) => (
                            <div
                                key={node.type}
                                className="wf-node-item"
                                onDragStart={(event) => onDragStart(event, node.type)}
                                draggable
                            >
                                {node.label}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </aside>
    );
};

export default Sidebar;
